<div
  class="flex min-h-[100dvh] flex-col"
  [style.backgroundColor]="backgroundColor() | contentBuilderColor"
  [style.backgroundImage]="backgroundImageCss()"
  [style.backgroundSize]="backgroundImageCss() ? 'cover' : null"
  [style.backgroundPosition]="backgroundImageCss() ? 'center' : null"
  [style.backgroundRepeat]="backgroundImageCss() ? 'no-repeat' : null"
>
  @if (header(); as headerValue) {
    <div class="flex-shrink-0">
      <app-block-list [blockIdList]="headerValue"></app-block-list>
    </div>
  }

  <div
    class="flex flex-1 items-center w-full md:mx-auto md:max-w-md"
    [class.pb-page-bottom]="bottomPadding() === 'auto'"
    [class.pb-8]="bottomPadding() === 'small'"
    [class.pb-16]="bottomPadding() === 'medium'"
    [class.pb-32]="bottomPadding() === 'large'"
    [class.pb-44]="bottomPadding() === 'xlarge'"
  >
    <div class="w-full">
      <app-block-list [blockIdList]="content() ?? []"></app-block-list>
      <app-block-list [blockIdList]="body() ?? []"></app-block-list>
      <app-block-list [blockIdList]="bottomContent() ?? []"></app-block-list>
      @if (steps()?.[0]?.block) {
        <div class="mt-24 hidden kiosk:block">
          <div class="mx-auto max-w-md p-4 align-middle">
            <app-button-atom
              [size]="'L'"
              [type]="'primary'"
              (click)="submit()"
              [disabled]="!isFormValid"
              [label]="
                (isLastItem ? 'cart-funnel.confirm-my-order' : 'cart-funnel.button-continue')
                  | translate
              "
            ></app-button-atom>
          </div>
        </div>
      }
    </div>
  </div>

  @if (steps()?.[0]?.block) {
    <div class="w-full flex-shrink-0 bg-white shadow-top kiosk:hidden">
      <div class="mx-auto max-w-md p-4 align-middle">
        <app-button-atom
          [size]="'L'"
          [type]="'primary'"
          (click)="submit()"
          [disabled]="!isFormValid"
          [label]="
            (isLastItem ? 'cart-funnel.confirm-my-order' : 'cart-funnel.button-continue')
              | translate
          "
        ></app-button-atom>
      </div>
    </div>
  }
</div>
